let defaultConfig = {
  domain: "",
  expires: "1d",
  path: "; path=/",
  //sameSite: "; SameSite=Lax",
  sameSite: "",
  secure: ""
};
import moment from 'moment'
import { MD5 } from '@/utils/RSA/MD5';
export default {
  hideSensitiveData: 'N',
  sethideSensitiveData(data) {
    this.hideSensitiveData = data;
  },
  //判断是否为空
  IsNull(v) {
    return typeof (v) === "undefined" || v === "" || v == null || v === "null" || v === "undefined";
  },

  //判断是否为“string”类型
  IsString(o) {
    return typeof (o) === "string";
  },

  //判断是否是函数
  isFunction(a) {
    return typeof (a) === "function";
  },

  //判断是否是数组
  IsArray(obj) {
    return Object.prototype.toString.call(obj) === '[object Array]';
  },

  //判断是否是日期
  IsDate(obj) {
    return (obj instanceof Date);
  },

  //获取cookies
  getCookie(key) {
    var value = decodeURIComponent(document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' + encodeURIComponent(key).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')) || null;

    if (value && value.substring(0, 1) === '{' && value.substring(value.length - 1, value.length) === '}') {
      try {
        value = JSON.parse(value);
      } catch (e) {
        return value;
      }
    }
    return value;
  },

  //设置cookies
  setCookie: function (key, value, expireTimes, path, domain, secure, sameSite) {
    if (!key) {
      throw new Error('Cookie name is not find in first argument.');
    } else if (/^(?:expires|max\-age|path|domain|secure|SameSite)$/i.test(key)) {
      throw new Error('Cookie key name illegality, Cannot be set to ["expires","max-age","path","domain","secure","SameSite"]\t current key name: ' + key);
    }
    // support json object
    if (value && value.constructor === Object) {
      value = JSON.stringify(value);
    }
    var _expires = '';
    expireTimes = expireTimes == undefined ? defaultConfig.expires : expireTimes;
    if (expireTimes && expireTimes != 0) {
      switch (expireTimes.constructor) {
        case Number:
          if (expireTimes === Infinity || expireTimes === -1) _expires = '; expires=Fri, 31 Dec 9999 23:59:59 GMT';
          else _expires = '; max-age=' + expireTimes;
          break;
        case String:
          if (/^(?:\d+(y|m|d|h|min|s))$/i.test(expireTimes)) {
            // get capture number group
            var _expireTime = expireTimes.replace(/^(\d+)(?:y|m|d|h|min|s)$/i, '$1');
            // get capture type group , to lower case
            switch (expireTimes.replace(/^(?:\d+)(y|m|d|h|min|s)$/i, '$1').toLowerCase()) {
              // Frequency sorting
              case 'm':
                _expires = '; max-age=' + +_expireTime * 2592000;
                break; // 60 * 60 * 24 * 30
              case 'd':
                _expires = '; max-age=' + +_expireTime * 86400;
                break; // 60 * 60 * 24
              case 'h':
                _expires = '; max-age=' + +_expireTime * 3600;
                break; // 60 * 60
              case 'min':
                _expires = '; max-age=' + +_expireTime * 60;
                break; // 60
              case 's':
                _expires = '; max-age=' + _expireTime;
                break;
              case 'y':
                _expires = '; max-age=' + +_expireTime * 31104000;
                break; // 60 * 60 * 24 * 30 * 12
              default:
                new Error('unknown exception of "set operation"');
            }
          } else {
            _expires = '; expires=' + expireTimes;
          }
          break;
        case Date:
          _expires = '; expires=' + expireTimes.toUTCString();
          break;
      }
    }
    document.cookie =
      encodeURIComponent(key) + '=' + encodeURIComponent(value) +
      _expires +
      (domain ? '; domain=' + domain : defaultConfig.domain) +
      (path ? '; path=' + path : defaultConfig.path) +
    (secure == undefined ? defaultConfig.secure : secure ? '; Secure' : '') +
    (sameSite == undefined ? defaultConfig.sameSite : (sameSite ? '; SameSite=' + sameSite : ''));
    return this;
  },

  //删除cookies
  delCookie(key, path, domain) {
    if (!key || !this.isKey(key)) {
      return false;
    }
    document.cookie = encodeURIComponent(key) +
      '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' +
      (domain ? '; domain=' + domain : defaultConfig.domain) +
      (path ? '; path=' + path : defaultConfig.path)
      //+
      //'; SameSite=Lax';
    return this;
  },

  //对象克隆
  objClone(myObj) {
    if (IsNull(myObj)) return myObj;
    if (typeof (myObj) != 'object') return myObj;
    var myNewObj = new Object();
    for (var i in myObj) {
        if (!IsNull(myObj[i]) && !IsNull(myObj[i].length) && myObj[i].push)
            myNewObj[i] = myObj[i].clone();
        else
            myNewObj[i] = objClone(myObj[i]);
    }
    return myNewObj;
  },

  //数据克隆
  clone(oldArr) {
    var newArr = new Array();
    for (var i = 0; i <= oldArr.length - 1; i++) {
        var itemi = oldArr[i];
        if (itemi.length && itemi.push) itemi = itemi.clone();//数组对象，进行递归
        else if (typeof (itemi) == "object") itemi = objClone(itemi);//非数组对象，用上面的objClone方法克隆
        newArr.push(itemi);
    }
    return newArr;
  },

  formatDate: function (row, column) {
    var date = row[column.property];

    if (date == undefined) { return '' };

    return moment(date).format("YYYY-MM-DD HH:mm:ss")
  },

  transIdCard(idCardType, idCard) {
    if (this.hideSensitiveData == 'N')
      return idCard;
    if (this.IsNull(idCard))
      return '';
    if (idCardType == 1) {
      if (idCard.length == 18)
        return idCard.substring(0, 6) + "****" + idCard.substring(14, 18);
      else
        return idCard.substring(0, 4) + "****" + idCard.substring(13, 15);
    }
    else if (idCardType == 6) {
      return idCard;
    }
    else {
      if (idCard.length == 18)
        return idCard.substring(0, 6) + "****" + idCard.substring(14, 15);
      else if (idCard.length > 4)
        return idCard.substring(0, 2) + "****" + idCard.substring(idCard.length - 2, idCard.length);
      else if (idCard.length <= 4 && idCard.length > 2)
        return idCard.substring(0, 1) + "****" + idCard.substring(idCard.length - 1, idCard.length);
      else
        return idCard;
    }
  },

  transTel(tel) {
    if (this.hideSensitiveData == 'N')
      return tel;
    if (this.IsNull(tel))
      return '';
    if (tel.length == 11)
      return tel.substring(0, 3) + "****" + tel.substring(7, 11);
    else if (tel.length == 8)
      return tel.substring(0, 2) + "****" + tel.substring(6, 8);
    else
      return tel.substring(0, 2) + "****" + tel.substring(tel.length - 2, tel.length);
  },

  Md5Encrypt(val) {
    return MD5(val);
  }
}



// WEBPACK FOOTER //
// ./src/utils/common.js